/**
 * UUID display helpers.
 *
 * Murmuration's account ids are UUIDv7s. The first 48 bits of a v7 are a Unix
 * millisecond timestamp, so the first 12 hex characters of two ids
 * minted in the same millisecond are identical, and the first 8 are
 * identical for anything minted in roughly the same hour. The
 * row-discriminating bits sit at the END.
 *
 * `shortenId` therefore renders the **last** `SHORT_ID_TAIL` hex chars,
 * prefixed with an ellipsis to signal truncation. The full id is always
 * available via the `title` attribute on table cells and verbatim on
 * the detail page's Identifiers section, so the trade-off is purely
 * visual density.
 */

export const SHORT_ID_TAIL = 12

export function shortenId(id: string): string {
  if (id.length <= SHORT_ID_TAIL) return id
  return `...${id.slice(-SHORT_ID_TAIL)}`
}
